module.exports = __webpack_public_path__ + "img/br.ef701aba.svg";